import { MedicineBoxOutlined } from '@ant-design/icons';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useOperationsDashboardContext } from '../../contexts/OperationsDashboardContext';
import styles from '../OperationsDashboard/ops-theme.module.css';

const OpsPhlebotomistTab: FC = () => {
  const { t } = useTranslation('dashboard.OperationsDashboard');
  const { phlebotomistSettings, opsSettings } = useOperationsDashboardContext();

  return (
    <div className={`${styles.placeholderTab} ${styles.animFadeUp}`}>
      <div className={styles.placeholderIcon}>
        <MedicineBoxOutlined />
      </div>
      <div className={styles.placeholderTitle}>{t('tabPhlebotomist')}</div>
      <div className={styles.placeholderDescription}>
        {t('placeholderDescription')}
      </div>
      {opsSettings.showDebug && phlebotomistSettings && (
        <div className={styles.caption} style={{ marginTop: 16 }}>
          Phlebotomist settings loaded:{' '}
          {Object.keys(phlebotomistSettings).length} keys
        </div>
      )}
    </div>
  );
};

export default OpsPhlebotomistTab;
